import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const { REACT_APP_PROXY_HOST } = process.env;

const useStyles = makeStyles((theme) => ({
  root: { width: '100%' },
  paper: { marginTop: theme.spacing(3), width: '100%', overflowX: 'auto', marginBottom: theme.spacing(2) },
  table: { minWidth: 650 },
}));

const ErreurList = () => {
  const [erreurs, setErreurs] = useState([]);
  const [camIdSearch, setCamIdSearch] = useState('');
  const [camIdSort, setCamIdSort] = useState('asc');
  const [dateSort, setDateSort] = useState('desc');
  const [messageFiltre, setMessageFiltre] = useState('');
  const [typeAppareilFilter, setTypeAppareilFilter] = useState('Tout');
  const [typeAppareilOptions, setTypeAppareilOptions] = useState(['Tout']);
  const classes = useStyles();

  useEffect(() => {
    fetch(REACT_APP_PROXY_HOST + '/log/erreurs', { method: 'GET' })
      .then((res) => res.json())
      .then((resErreurs) => setErreurs(resErreurs));
  }, []);

  useEffect(() => {
    const types = new Set(erreurs.map((erreur) => erreur.typeappareil));
    setTypeAppareilOptions(['Tout', ...types]);
  }, [erreurs]);

  const displayCond = (erreur) => {
    if (!camIdSearch) {
      return true;
    }
    return erreur && erreur.appareilid === camIdSearch.toString();
  };

  const afficheMessage = (erreur) => (!messageFiltre ? true : erreur && erreur.message.includes(messageFiltre));
  const afficheTypeAppareil = (erreur) => typeAppareilFilter === 'Tout' || erreur.typeappareil === typeAppareilFilter;

  const handleSortAppareil = () => {
    const nextSort = camIdSort === 'asc' ? 'desc' : 'asc';
    setCamIdSort(nextSort);
    const sortedErreurs = [...erreurs].sort((a, b) => (nextSort === 'asc' ? a.appareilid - b.appareilid : b.appareilid - a.appareilid));
    setErreurs(sortedErreurs);
  };

  const handleSortDate = () => {
    const nextSort = dateSort === 'asc' ? 'desc' : 'asc';
    setDateSort(nextSort);
    const sortedErreurs = [...erreurs].sort((a, b) => (nextSort === 'asc' ? a.date - b.date : b.date - a.date));
    setErreurs(sortedErreurs);
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <h1>Erreurs</h1>
        <button onClick={() => { setCamIdSearch(''); setMessageFiltre(''); }}>Reinitialiser</button>
        <Table className={classes.table} size="small">
          <TableHead>
            <TableRow>
              <TableCell onClick={handleSortAppareil}>AppareilID {camIdSort === 'asc' ? '?' : '?'}</TableCell>
              <TableCell align="right">Type Appareil</TableCell>
              <TableCell align="right">Niveau</TableCell>
              <TableCell align="right">Message</TableCell>
              <TableCell onClick={handleSortDate}>Date {dateSort === 'asc' ? '?' : '?'}</TableCell>
              <TableCell align="right">Derniere mise a jour</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell><input type="text" value={camIdSearch} onChange={(e) => setCamIdSearch(e.target.value)} /></TableCell>
              <TableCell align="right"><Select value={typeAppareilFilter} onChange={(e) => setTypeAppareilFilter(e.target.value)}>{typeAppareilOptions.map((option) => <MenuItem key={option} value={option}>{option}</MenuItem>)}</Select></TableCell>
              <TableCell align="right"><input type="text" /></TableCell>
              <TableCell><input type="text" value={messageFiltre} onChange={(e) => setMessageFiltre(e.target.value)} /></TableCell>
              <TableCell align="right"><input type="text" /></TableCell>
              <TableCell align="right"><input type="text" /></TableCell>
            </TableRow>
            {erreurs.map((erreur) => ((displayCond(erreur) && afficheTypeAppareil(erreur) && afficheMessage(erreur)) ? (
              <TableRow key={erreur.erreurid}>
                <TableCell component="th" scope="row">{erreur.appareilid}</TableCell>
                <TableCell align="right">{erreur.typeappareil}</TableCell>
                <TableCell align="right">{erreur.niveau}</TableCell>
                <TableCell align="right">{erreur.message}</TableCell>
                <TableCell align="right">{(new Date(parseInt(erreur.date, 10))).toLocaleString()}</TableCell>
                <TableCell align="right">{(new Date(parseInt(erreur.derniermaj, 10))).toLocaleString()}</TableCell>
              </TableRow>
            ) : null))}
          </TableBody>
        </Table>
      </Paper>
    </div>
  );
};

export default ErreurList;



// WEBPACK FOOTER //
// src/components/erreurs/ErreurList.js